
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function PuneToHarihareshwarTaxi() {



  const cardData =
  {
    keyword: 'Pune to Harihareshwar Taxi Service',
    heading: 'AB Ghule Cabs: Pune to Harihareshwar Taxi Service',
    headingDescription: 'Looking for a peaceful escape to Harihareshwar from Pune? AB Ghule Cabs provides reliable, comfortable, and affordable taxi services to make your journey smooth and hassle-free. Whether you are visiting for a spiritual retreat or a relaxing vacation, our professional drivers and well-maintained vehicles ensure a pleasant trip to one of Maharashtra’s serene coastal destinations. The approximate distance from Pune to Harihareshwar is around 170 km.',

    top: 'Top Places to Visit in Harihareshwar with AB Ghule Cabs',

   "topPlaces": [
  {
    title: "Harihareshwar Temple",
    description: "The Harihareshwar Temple, dedicated to Lord Shiva, is the town’s most revered landmark. Situated on the shore, the temple provides a serene atmosphere and is a must-visit for devotees seeking spiritual solace."
  },
  {
    title: "Harihareshwar Beach",
    description: "This peaceful beach is perfect for a quiet retreat. With its clean surroundings and calm waters, it’s ideal for beach walks, sunbathing, or simply relaxing by the sea."
  },
  {
    title: "Kalbhairav Temple",
    description: "Located near Harihareshwar, this temple is dedicated to Kalbhairav, a fierce manifestation of Lord Shiva. It holds spiritual significance and is a must-visit for religious tourists."
  },
  {
    title: "Anjarle Beach",
    description: "Situated around 30 km from Harihareshwar, Anjarle Beach is a beautiful and relatively less-crowded spot, offering clean sand and clear waters, perfect for swimming and relaxation."
  },
  {
    title: "Diveagar Beach",
    description: "A short drive from Harihareshwar, Diveagar Beach is known for its golden sands and calm environment. It’s a great place to unwind and enjoy the natural beauty of the coastline."
  },
  {
    title: "Shrivardhan Beach",
    description: "Located nearby, Shrivardhan Beach is perfect for those looking for a peaceful atmosphere. It’s a beautiful destination for a quiet walk along the shore."
  },
  {
    title: "Kondvil Beach",
    description: "Kondvil Beach is a hidden gem near Harihareshwar, offering tranquility and natural beauty. A great place for a quiet beach experience away from the crowds."
  },
  {
    title: "Suvarna Ganesh Temple",
    description: "A small temple situated near the Harihareshwar Temple, Suvarna Ganesh Temple is dedicated to Lord Ganesh and is a revered spot for spiritual seekers."
  },
  {
    title: "Revdanda Fort",
    description: "Situated close to Harihareshwar, this historic fort offers panoramic views of the sea. It’s an excellent spot for history enthusiasts and nature lovers alike."
  },
  {
    title: "Vashishti River",
    description: "The Vashishti River offers a peaceful backdrop for sightseeing and boating. You can enjoy a boat ride or simply relax along its banks, appreciating the quiet beauty of the river."
  }
],


services: [
    {
      "name": "Pune to Harihareshwar Taxi Fare",
      description: "Plan your trip from Pune to Harihareshwar with transparent and affordable taxi fares. At AB Ghule Cabs, we ensure that you get the best rates for your journey, with no hidden charges."
    },
    {
      "name": "Pune to Harihareshwar Cab Charges",
      description: "Our Pune to Harihareshwar cab charges are budget-friendly and flexible, providing you with various options to suit your travel preferences. Book with confidence and enjoy a hassle-free experience."
    },
    {
      "name": "Pune to Harihareshwar Taxi Booking",
      description: "Book your taxi from Pune to Harihareshwar online with AB Ghule Cabs. We offer a quick and easy booking process, ensuring that your trip is smooth from start to finish. Choose from a range of vehicles for your convenience."
    },
    {
      "name": "Pune to Harihareshwar Car Rental",
      description: "AB Ghule Cabs offers a variety of car rental options for your journey from Pune to Harihareshwar. Whether you need a sedan, SUV, or luxury car, we have the perfect vehicle for you."
    },
    {
      "name": "Pune to Harihareshwar Taxi Rates",
      description: "Check out our competitive taxi rates for the Pune to Harihareshwar route. We provide the best pricing to ensure a comfortable and affordable journey, whether you're booking a one-way or round-trip service."
    },
    {
      "name": "Pune to Harihareshwar Cab Pricing",
      description: "Our transparent cab pricing ensures you get the most value for your money. Enjoy a comfortable ride from Pune to Harihareshwar with AB Ghule Cabs, offering clear and upfront costs for your trip."
    },
    {
      "name": "Pune to Harihareshwar Private Car Hire",
      description: "If you prefer a more private travel experience, book a private car hire from Pune to Harihareshwar. AB Ghule Cabs offers a wide selection of vehicles, allowing you to travel with privacy and comfort."
    },
    {
      "name": "Pune to Harihareshwar Cab Cost",
      description: "The cost of your taxi from Pune to Harihareshwar is calculated based on the distance and the vehicle type. We offer affordable pricing for all types of travelers, ensuring an enjoyable and economical journey."
    },
    {
      "name": "Pune to Harihareshwar Taxi Service Charges",
      description: "At AB Ghule Cabs, our taxi service charges are reasonable, with no hidden fees. We provide all-inclusive rates, so you know exactly what you’re paying for from start to finish."
    },
    {
      "name": "Pune to Harihareshwar Travel Fare",
      description: "Calculate your travel fare from Pune to Harihareshwar easily using our fare estimator. We offer competitive pricing for your journey, making it both affordable and comfortable."
    },
    {
      "name": "Pune to Harihareshwar by Car",
      description: "Whether you're traveling solo or with a group, we offer car rentals for your trip from Pune to Harihareshwar. Choose from a range of options, including sedans, SUVs, and more, to make your trip more enjoyable."
    },
    {
      "name": "Pune to Harihareshwar Innova Cab",
      description: "Book an Innova cab for your journey from Pune to Harihareshwar with AB Ghule Cabs. The spacious and comfortable Innova is ideal for families and groups, providing ample room for a comfortable ride."
    },
    {
      "name": "Pune to Harihareshwar Innova Crysta",
      description: "Experience luxury and comfort with an Innova Crysta for your trip from Pune to Harihareshwar. AB Ghule Cabs offers premium services with this elegant vehicle, ensuring a smooth and stylish ride."
    },
    {
      "name": "Pune to Konkan Darshan Taxi",
      description: "Explore the beautiful Konkan coast with a taxi service from Pune to Harihareshwar. AB Ghule Cabs offers dedicated Konkan Darshan tours, including visits to Harihareshwar, ensuring a memorable and scenic trip."
    },
    {
      "name": "Pune to Harihareshwar Tempo Traveller on Rent",
      description: "For group travel, AB Ghule Cabs offers Tempo Traveller rentals for your trip from Pune to Harihareshwar. Choose from our fleet of vehicles for a spacious and comfortable journey with friends or family."
    },
    {
      "name": "Pune to Harihareshwar Swift Dzire on Rent",
      description: "Looking for a compact yet comfortable car for your journey from Pune to Harihareshwar? Rent a Swift Dzire from AB Ghule Cabs and enjoy a cost-effective and smooth ride."
    },
    {
      "name": "Pune to Harihareshwar Kia Carens on Rent",
      description: "Travel in style with a Kia Carens on rent for your trip from Pune to Harihareshwar. AB Ghule Cabs offers the Kia Carens, known for its comfort, luxury, and ample space for group travel."
    },
    {
      "name": "Pune to Harihareshwar Mini Bus on Rent",
      description: "For larger groups, AB Ghule Cabs offers mini buses on rent for your journey to Harihareshwar. With seating for up to 25 passengers, these mini buses are perfect for corporate trips or family gatherings."
    },
    {
      "name": "Pimpri Chinchwad to Harihareshwar Cab",
      description: "If you're in Pimpri Chinchwad and need a cab to Harihareshwar, AB Ghule Cabs is the best option. Our reliable taxi service will ensure you reach Harihareshwar safely and comfortably from Pimpri Chinchwad."
    },
    {
      "name": "Pune to Harihareshwar Taxi Contact Number",
      description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Pune to Harihareshwar Taxi. We ensure a smooth and enjoyable ride for all our customers."
    }
  ],

  tableData: [
    ["Pune to Harihareshwar Taxi Fare", "Pune to Harihareshwar Cab Charges"],
    ["Pune to Harihareshwar Taxi Booking", "Pune to Harihareshwar Car Rental"],
    ["Pune to Harihareshwar Taxi Rates", "Pune to Harihareshwar Cab Pricing"],
    ["Pune to Harihareshwar Private Car Hire", "Pune to Harihareshwar Cab Cost"],
    ["Pune to Harihareshwar Taxi Service Charges", "Pune to Harihareshwar Travel Fare"],
    ["Pune to Harihareshwar by Car", "Pune to Harihareshwar Innova Cab"],
    ["Pune to Harihareshwar Innova Crysta", "Pune to Konkan Darshan Taxi"],
    ["Pune to Harihareshwar Tempo Traveller on Rent", "Pune to Harihareshwar Swift Dzire on Rent"],
    ["Pune to Harihareshwar Kia Carens on Rent", "Pune to Harihareshwar Mini Bus on Rent"],
    ["Pimpri Chinchwad to Harihareshwar Cab", "Pune to Harihareshwar Taxi Contact Number"]
  ],
  
  whychoose: [
    {
      WhyChooseheading: "Reliable and Comfortable Service",
      WhyChoosedescription: "AB Ghule Cabs ensures a smooth and enjoyable journey from Pune to Harihareshwar for both leisure and religious trips."
    },
    {
      WhyChooseheading: "Competitive and Transparent Pricing",
      WhyChoosedescription: "We offer affordable and transparent pricing, ensuring you receive great value without hidden charges."
    },
    {
      WhyChooseheading: "Well-Maintained Fleet",
      WhyChoosedescription: "Our vehicles are well-maintained, clean, and serviced regularly to ensure a safe and comfortable journey."
    },
    {
      WhyChooseheading: "Experienced and Professional Drivers",
      WhyChoosedescription: "Our professional drivers are courteous and well-versed with the routes, ensuring a safe, timely, and comfortable trip."
    },
    {
      WhyChooseheading: "On-Time Pick-Up and Drop-Off",
      WhyChoosedescription: "We guarantee punctual pick-up and drop-off services to ensure you enjoy a stress-free journey to Harihareshwar."
    },
    {
      WhyChooseheading: "Easy and Convenient Booking Process",
      WhyChoosedescription: "Booking your taxi is simple through our website, app, or customer service, ensuring a hassle-free experience."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription: "We offer round-the-clock availability, so you're never without a ride when you need one."
    }
  ]
  
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a taxi from Pune to Harihareshwar?',
      answer: 'You can easily book your taxi online through our website, mobile app, or by calling our customer service team for assistance.',
    },
    {
      id: 'FAQ2',
      question: 'What is the fare for a one-way trip from Pune to Harihareshwar?',
      answer: 'The one-way fare for a sedan typically ranges from ₹3,500 to ₹4,500. The exact fare depends on the vehicle and other factors.',
    },
    {
      id: 'FAQ3',
      question: 'Are the fares inclusive of taxes and tolls?',
      answer: 'Yes, all fares are inclusive of taxes, tolls, and other charges. There are no hidden fees.',
    },
    {
      id: 'FAQ4',
      question: 'How long will the journey from Pune to Harihareshwar take?',
      answer: 'The journey typically takes 4 to 5 hours, depending on traffic conditions.',
    },
    {
      id: 'FAQ5',
      question: 'Can I book a round trip from Pune to Harihareshwar?',
      answer: 'Yes, we offer round-trip bookings. You can contact us for details and to get the best rates.',
    },
    {
      id: 'FAQ6',
      question: 'Do you offer pick-up from any location in Pune?',
      answer: 'Yes, we provide pick-up from any location in Pune, including homes, offices, hotels, and more.',
    },
    {
      id: 'FAQ7',
      question: 'Are the vehicles air-conditioned?',
      answer: 'Yes, all our vehicles are air-conditioned for your comfort.',
    },
    {
      id: 'FAQ8',
      question: 'Can I choose the vehicle for my trip?',
      answer: 'Yes, you can choose from a range of vehicles, including sedans, SUVs, and luxury cars, depending on your needs.',
    },
    {
      id: 'FAQ9',
      question: 'How do I pay for the taxi service?',
      answer: 'You can pay via cash, credit/debit card, or through our mobile app, making the payment process quick and easy.',
    },
    {
      id: 'FAQ10',
      question: 'Are there any extra charges for waiting or detours?',
      answer: 'Additional charges may apply for waiting time or detours, and these will be communicated to you in advance.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Ramesh Joshi',
      feedback: 'I had a wonderful trip from Pune to Harihareshwar with AB Ghule Cabs. The driver was very professional, and the car was comfortable. The trip was smooth, and we reached on time without any issues. I will definitely use their services again.',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Sunita Deshmukh',
      feedback: 'AB Ghule Cabs made our journey to Harihareshwar extremely comfortable. The vehicle was clean, and the driver was friendly and knowledgeable about the route. The pricing was reasonable, and we had a hassle-free experience.',
      rating: 5,
    },
  ];
  
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune to Harihareshwar Taxi Fare | Affordable Cab & Car Rental Services</title>
  <meta name="description" content="Book a taxi from Pune to Harihareshwar with AB Ghule Cabs. Get the best fares for one-way and round trip cabs. Affordable car rental services available. Call +91 8624029699 for bookings." />
  <meta name="keywords" content="Pune to Harihareshwar Taxi Fare, Pune to Harihareshwar Cab Charges, Pune to Harihareshwar Taxi Booking, Pune to Harihareshwar Car Rental, Pune to Harihareshwar Taxi Rates, Pune to Harihareshwar Cab Pricing, Pune to Harihareshwar Private Car Hire, Pune to Harihareshwar Cab Cost, Pune to Harihareshwar Taxi Service Charges, Pune to Harihareshwar Travel Fare, Pune to Harihareshwar by Car, Pune to Harihareshwar Innova Cab, Pune to Harihareshwar Innova Crysta, Pune to Konkan Darshan Taxi, Pune to Harihareshwar Tempo Traveller on Rent, Pune to Harihareshwar Swift Dzire on Rent, Pune to Harihareshwar Kia Carens on Rent, Pune to Harihareshwar Mini Bus on Rent, Pimpri Chinchwad to Harihareshwar Cab" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Pune to Harihareshwar Taxi Fare | Affordable Cab & Car Rental Services" />
  <meta property="og:description" content="Book a taxi from Pune to Harihareshwar with AB Ghule Cabs. Get the best fares for one-way and round trip cabs. Affordable car rental services available. Call +91 8624029699 for bookings." />
  <meta property="og:image" content="https://abghulecabs.com/images/pune-to-harihareshwar-taxi.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/pune-to-harihareshwar-taxi" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Pune to Harihareshwar Taxi",
        description: "Book a taxi from Pune to Harihareshwar with AB Ghule Cabs. Get the best fares for one-way and round trip cabs. Affordable car rental services available. Call +91 8624029699 for bookings.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/pune-to-harihareshwar-taxi",
        "logo": "https://abghulecabs.com/images/pune-to-harihareshwar-taxi.jpg",
        "image": "https://abghulecabs.com/images/pune-to-harihareshwar-taxi.jpg",
        "priceRange": "₹3000 - ₹7000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/pune-to-harihareshwar-taxi",
          "priceCurrency": "INR",
          "price": "3000",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "100"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Anil D"
            },
            "datePublished": "2024-11-05",
            "reviewBody": "The ride to Harihareshwar was smooth and comfortable. The driver was very friendly and knowledgeable about the area. Great service!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Sanjay K"
            },
            "datePublished": "2024-10-20",
            "reviewBody": "Booked a Swift Dzire for my family trip to Harihareshwar. It was a fantastic experience. Clean car and punctual service."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune to Harihareshwar Taxi Service",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "17.8928",
            "longitude": "73.4007"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/pune-to-harihareshwar-taxi"
        },
        "keywords": "Pune to Harihareshwar Taxi Fare, Pune to Harihareshwar Cab Charges, Pune to Harihareshwar Taxi Booking, Pune to Harihareshwar Car Rental, Pune to Harihareshwar Taxi Rates, Pune to Harihareshwar Cab Pricing, Pune to Harihareshwar Private Car Hire, Pune to Harihareshwar Cab Cost, Pune to Harihareshwar Taxi Service Charges, Pune to Harihareshwar Travel Fare, Pune to Harihareshwar by Car, Pune to Harihareshwar Innova Cab, Pune to Harihareshwar Innova Crysta, Pune to Konkan Darshan Taxi, Pune to Harihareshwar Tempo Traveller on Rent, Pune to Harihareshwar Swift Dzire on Rent, Pune to Harihareshwar Kia Carens on Rent, Pune to Harihareshwar Mini Bus on Rent, Pimpri Chinchwad to Harihareshwar Cab"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/51.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default PuneToHarihareshwarTaxi;